export const generateRandomNumber = (data) => Math.floor(Math.random() * data.length);

export const generateRandomPair = (data) => {
    const newPair = []
    for (let index = 0; index < data.length; index++) {
      let randomIndex = generateRandomNumber(data) ;
      if(randomIndex === index) {
        randomIndex = typeof data[randomIndex] === 'undefined' || data.length === randomIndex ? randomIndex - 1 : randomIndex + 1 ;
      } 
      newPair.push({
        font2: data[index].font,
        url2: data[index].url,
        font1: data[randomIndex].font,
        url1: data[randomIndex].url,
      })
    }
    return newPair;
}

export const regexSearch = (item, searchInputValue) => item?.likedPair?.toString().search(new RegExp(searchInputValue?.replace(/[^a-zA-Z0-9 ]/g, ''), "i")) !== -1
